/**
 * Ryan O'Dowd
 * 2024-02-12
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import CPassage from '@classes/Passage';
import Icon from '@react-native-vector-icons/material-design-icons';
import Passage from '@components/Passage';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const VerseMemory = (props: VerseMemoryProps) => {
  const styles = hooks.useStyles(getStyles);

  const _renderInstructions = () => {
    /* @TODO: move to help menu or something
      You can practice a sub-selection of verses, but only full selections count towards group-goal lessons
      same with other difficulties and game types
    */

    return (
      <View style={styles.instructionsWrapper}>{/* @TODO: i18n these */}
        {(!!props.progress.nlr && !props.must_memorize) &&
          <View style={styles.textWrapper}>
            <View style={styles.textAndIconWrapper}>
              <View style={styles.multilineText}>
                <Text style={styles.instructionsText}>
                  Must complete at least <Text style={[styles.instructionsText, styles.boldText]}>{props.progress.nlr} {props.progress.nlr === 1 ? 'lesson' : 'lessons'}</Text>{!!props.game_difficulty && <Text style={styles.instructionsText}> on <Text style={[styles.instructionsText, styles.boldText]}>{props.game_difficulty}</Text> difficulty</Text>}.
                </Text>
                <Text style={styles.instructionsText}>
                  <Text style={[styles.instructionsText, styles.boldText]}>{props.progress.nlc} </Text>out of <Text style={[styles.instructionsText, styles.boldText]}>{props.progress.nlr} </Text>{props.progress.nlr === 1 ? 'lesson' : 'lessons'} completed.{/* @TODO: this number doesn't seem to update automatically after a lesson is completed...requires a refresh */}
                </Text>
              </View>
              <View style={styles.iconsWrapper}>
                <Icon style={styles.icon} name='school' size={24} color={styles.colors.white} />
              </View>
            </View>
          </View>
        }

        {/* @TODO: these are mutually exclusive for right now
        {(!!props.progress.nlr && !!props.must_memorize) && <View style={styles.spacerLine} />}
        */}

        {!!props.must_memorize &&
          <View style={styles.textAndIconWrapper}>
            <Text style={styles.instructionsText}>{`Memorize ${props.passage.start_verse_number === props.passage.end_verse_number ? 'this verse' : 'these verses'} (must get to at least level 3${props.passage.start_verse_number === props.passage.end_verse_number ? '' : ' for each verse'})`}</Text>
            <Icon style={styles.icon} name='test-tube' size={24} color={styles.colors.white} />
          </View>
        }

      </View>
    );
  };

  const __w = hooks.useTypedSelector((state) => state.wrinkles); // @TODO: this is hacky...only listening to this to trigger a re-render of this component when wrinkles change (because the passage prop doesn't change, there's no re-render after successfully leveling up a verse...can't repro on simulator)

  return (
    <View style={styles.container}>
      {props.showInstructions && _renderInstructions()}
      <Passage
        passage={props.passage}
        assignmentId={props.assignmentId}
        normalizedScore={props.progress.nlc / props.progress.nlr}
        isExpanded={props.showInstructions || props.isExpanded}// @TODO: is the best way to determine that this is a group goal?
        difficultyOverride={props.game_difficulty}
        availableMinigamesOverride={props.game_types_enabled?.length ? props.game_types_enabled : undefined} // @TODO: should this come from the back end as undefined?
        hideActions={props.hideActions}
        spritzPassage={null}// verse memories don't need a spritz option
      />
    </View>
  );
};

class VerseMemoryProps {
  id: number;
  passage: CPassage;
  assignmentId: number;
  progress: {
    nlc: number;
    nlr: number;
  }; // @TODO: progress type

  game_difficulty?: 'easy' | 'medium' | 'hard';
  game_types_enabled?: number[];
  showInstructions?: boolean;
  must_memorize?: 0 | 1; // @TODO: 0 or 1...maybe cast to boolean?
  hideActions?: boolean;
  isExpanded?: boolean;
};

export default VerseMemory;
